import { call, put, takeEvery } from 'redux-saga/effects';
import { addUser } from '../../requests/add_user_request';
import { clearUsersCacheRequest } from '../../requests/clear_users_cache';
import { ADD_USER_REQUEST } from '../constants/add_user.constants';
import { addUserRequestSuccess, addUserRequestFailure } from '../actions/add_user.actions';
import { message_error, message_success } from '../../../../../components/Message';
import { getVal } from '../../../../../shared/helpers';
import { getErrorMessage } from '../../../../../shared/helpers';

function* addUserRequest({ params }) {
    try {
        const { result, msg, options, error } = yield call(addUser, params);

        if (result) {
            yield put(addUserRequestSuccess(options));
            message_success(msg);
            
            yield call(clearUsersCacheRequest);
        } else {
            yield put(addUserRequestFailure(error));
            message_error(getVal(error, 'code') === 11000 ? 'User already exist' : 'Error during invite user, please contact Admin');
        }
    } catch (error) {
        message_error(getErrorMessage(error));
    }
    
}

export default function* addUserSaga() {
    yield takeEvery(ADD_USER_REQUEST, addUserRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_create/redux/sagas/add_user.saga.js